module.exports = __webpack_public_path__ + "img/product-banner_2.b08342be.png";